import * as requestFromServer from './aspiranteCrud';
import * as requestFromServerPasoUno from '../pasoUno/pasoUnoCrud';

import { aspiranteSlice, callTypes } from './aspiranteSlice';

const { actions } = aspiranteSlice;

export const fetchAspiranteInformacion = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .getAspiranteInformacion(queryParams)
        .then(response => {
            const aspiranteInformacion = response.data;
            //console.log(aspiranteInformacion);
            dispatch(actions.aspiranteFetched({ aspiranteInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};


export const fetchAspiranteInformacionFromId = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServerPasoUno
        .getPasoFromId(queryParams)
        .then(response => {
            const aspiranteInformacion = response.data;
            //console.log("Respuesta Home");
            //console.log(aspiranteInformacion);
            dispatch(actions.aspiranteFetched({ aspiranteInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};


export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.reiniciarDatos());
};